import { defineMessages } from 'react-intl';

export default defineMessages({
  name: {
    id: 'ORGANIZATION.name',
    defaultMessage: 'Client',
  },
  company: {
    id: 'ORGANIZATION.company',
    defaultMessage: 'Client Company',
  },
  country: {
    id: 'ORGANIZATION.country',
    defaultMessage: 'Primary Country',
  },
  rules: {
    id: 'ORGANIZATION.rules',
    defaultMessage: 'Rules',
  },
  language: {
    id: 'ORGANIZATION.language',
    defaultMessage: 'Primary consultation language',
  },
  connectionStatus: {
    id: 'ORGANIZATION.connectionStatus',
    defaultMessage: 'Status',
  },
  companyAnalyst: {
    id: 'ORGANIZATION.companyAnalyst',
    defaultMessage: 'Authorize Analyst(s)',
  },
  information: {
    id: 'ORGANIZATION.clientInformation',
    defaultMessage: 'Client information',
  },
  settings: {
    id: 'ORGANIZATION.settings',
    defaultMessage: 'Client settings',
  },
  requiredClientUser: {
    id: 'ORGANIZATION.requiredClientUser',
    defaultMessage: 'Required client user',
  },
  addPerson: {
    id: 'ORGANIZATION.addPerson',
    defaultMessage: 'Add +',
  },
  introMessage: {
    id: 'ORGANIZATION.introMessage',
    defaultMessage: 'Select default Intro Message',
  },
});



// WEBPACK FOOTER //
// ./components/templates/OrganizationInformationForm/messages.js